<template>
  <div>
    <component :is="provider"></component>
  </div>
</template>
<script>
  import approved from './approved'
  import rejected from './rejected'
  export default{
    data(){
      return{
        provider: this.$route.params.payment ? this.$route.params.payment : null,
      }
    },
    components:{
      approved,
      rejected
    }
  }
</script>
